import {
  TABLE_MODE_AGG_OPTIONS_METRIC,
  TABLE_MODE_AGG_OPTIONS_DATE,
  TABLE_MODE_AGG_OPTIONS_DIMENSION,
  appendCountDistinctOption,
} from "./columnMappingConstants";

export function isDimensionOnlyAggregateValue(value) {
  const v = String(value || "").trim().toUpperCase();
  return v === "COUNT" || v === "COUNT_DISTINCT";
}

export function isDimensionAggregateValue(value) {
  const v = String(value || "").trim().toUpperCase();
  return v === "" || v === "COUNT" || v === "COUNT_DISTINCT";
}

export function isDateAggregateValue(value) {
  const v = String(value || "").trim().toUpperCase();
  return v === "YEAR" || v === "QUARTER" || v === "MONTH" || v === "YYYYMM";
}

/** Infer date grain / metric agg from an existing SELECT expression in saved datasql. */
export function inferAggregateFromSelectExpression(expression) {
  const e = String(expression || "").toUpperCase();
  if (/\bEXTRACT\s*\(\s*MONTH\b/.test(e)) return "MONTH";
  if (/\bEXTRACT\s*\(\s*YEAR\b/.test(e)) return "YEAR";
  if (/\bEXTRACT\s*\(\s*QUARTER\b/.test(e)) return "QUARTER";
  if (/\bTO_CHAR\s*\([^)]*YYYY\s*"?Q"?\s*Q/i.test(e)) return "QUARTER";
  if (/\bTO_CHAR\s*\([^)]*YYYYMM/i.test(e)) return "YYYYMM";
  if (/\bCOUNT\s*\(\s*DISTINCT\b/.test(e)) return "COUNT_DISTINCT";
  if (/\bCOUNT\s*\(/.test(e)) return "COUNT";
  if (/\bSUM\s*\(/.test(e)) return "SUM";
  if (/\bAVG\s*\(/.test(e)) return "AVG";
  if (/\bMIN\s*\(/.test(e)) return "MIN";
  if (/\bMAX\s*\(/.test(e)) return "MAX";
  return "";
}

export function isDateColumnRow(row) {
  return row && row.displayType === "Date";
}

export function aggregateSelectEnabledForRow(row) {
  if (!row) return false;
  return (
    row.displayType === "Metric" ||
    row.displayType === "Dimension" ||
    row.displayType === "Identifier" ||
    isDateColumnRow(row)
  );
}

export function aggregateOptionsForRow(row) {
  if (!row) return [{ value: "", text: "—" }];
  if (row.displayType === "Metric") {
    return appendCountDistinctOption(TABLE_MODE_AGG_OPTIONS_METRIC);
  }
  if (isDateColumnRow(row)) {
    return appendCountDistinctOption(TABLE_MODE_AGG_OPTIONS_DATE);
  }
  if (row.displayType === "Dimension" || row.displayType === "Identifier") {
    return TABLE_MODE_AGG_OPTIONS_DIMENSION;
  }
  return appendCountDistinctOption([
    { value: "", text: "—" },
    { value: "COUNT", text: "COUNT" },
  ]);
}

export function tableModeGraphSelectEnabledForRow(row) {
  return row && row.displayType === "Metric";
}

export function onTableColumnDisplayTypeChange(row) {
  if (!row) return;
  const agg = String(row.aggregate || "").trim().toUpperCase();
  if (row.displayType === "Metric") {
    if (
      !agg ||
      isDateAggregateValue(row.aggregate) ||
      isDimensionOnlyAggregateValue(row.aggregate)
    ) {
      row.aggregate = "SUM";
    }
  } else if (row.displayType === "Date") {
    if (!agg || !isDateAggregateValue(row.aggregate)) {
      row.aggregate = "YEAR";
    }
  } else if (
    row.displayType === "Dimension" ||
    row.displayType === "Identifier"
  ) {
    if (!isDimensionAggregateValue(row.aggregate)) {
      row.aggregate = "";
    }
  } else {
    row.aggregate = "";
  }
}
